import { render, staticRenderFns } from "./SubmitShoppingCartButton.vue?vue&type=template&id=34c2ab84&scoped=true"
import script from "./SubmitShoppingCartButton.vue?vue&type=script&lang=js"
export * from "./SubmitShoppingCartButton.vue?vue&type=script&lang=js"
import style0 from "./SubmitShoppingCartButton.vue?vue&type=style&index=0&id=34c2ab84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2ab84",
  null
  
)

export default component.exports